<template>
  <div class="modal-body">
    <p class="nz-info nz-text-error">{{ message }}</p>

    <div class="modal-actions">
      <button class="btn btn-primary" @click="$emit('close')">
        OK
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    required: true
  }
});
</script>
